import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import FancyHeading from '@/components/FancyHeading';
import IntroText from '@/components/IntroText';
import JobApplyForm from '@/components/JobApplyForm';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import mainLayout from '@/graphql/queries/mainLayout';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import graphql from '@/lib/graphql';
import { motion } from 'framer-motion';

export default function InitiativeApplicationPage({ mainLayout, metaData }) {
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <motion.div
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <BreadcrumbsBlock
          items={[pages.home, pages.careers, pages.initiativeApplication]}
          variants={fadeIn}
        />
        <section className="my-16 px-4">
          <div className="container-screen">
            <FancyHeading variants={fadeInUp}>{pages.initiativeApplication.text}</FancyHeading>
            <IntroText className="mt-6 max-w-screen-md" variants={fadeInUp}>
              Here you can send us an initiative application. If such a postition is available, you
              will be contacted for further information.
            </IntroText>
          </div>
        </section>
        <motion.section className="my-16 px-4" variants={fadeInUp}>
          <div className="container-screen">
            <div className="mx-auto mt-8 max-w-screen-md">
              <JobApplyForm
                job={{
                  title: 'Initiative Application',
                }}
              />
            </div>
          </div>
        </motion.section>
      </motion.div>
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const { data: mainLayoutData } = await graphql(mainLayout);

  return {
    props: {
      mainLayout: mainLayoutData.mainLayout.data,
      metaData: {
        metaTitle: 'Initiative Application',
      },
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
